import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", { d: "M17.434 5.857a.8.8 0 0 1-.225.865l-1.522 1.385a6.8 6.8 0 0 1 0 1.786l1.522 1.385a.8.8 0 0 1 .225.865q-.233.627-.555 1.206l-.166.285a9 9 0 0 1-.777 1.096.8.8 0 0 1-.86.24l-1.959-.623a6.8 6.8 0 0 1-1.547.893l-.44 2.008a.79.79 0 0 1-.64.625 9.1 9.1 0 0 1-2.987 0 .79.79 0 0 1-.64-.625l-.44-2.008a6.8 6.8 0 0 1-1.547-.893l-1.954.626a.8.8 0 0 1-.862-.239 9 9 0 0 1-.777-1.097l-.165-.285a9 9 0 0 1-.555-1.206.8.8 0 0 1 .225-.864L2.31 9.896a6.803 6.803 0 0 1 0-1.79L.788 6.723a.8.8 0 0 1-.225-.865q.232-.627.555-1.206l.165-.285q.35-.58.777-1.096a.8.8 0 0 1 .862-.24l1.958.623a6.8 6.8 0 0 1 1.547-.893l.44-2.008a.795.795 0 0 1 .639-.625 9.085 9.085 0 0 1 2.988-.004c.324.053.57.306.64.626l.44 2.007c.555.229 1.075.531 1.547.893l1.958-.622a.8.8 0 0 1 .861.239q.428.517.777 1.097l.165.285q.323.578.556 1.206zM9 11.813a2.812 2.812 0 1 0 0-5.625 2.812 2.812 0 0 0 0 5.625" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h18v18H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }